import { render } from "./zcfzTable.vue?vue&type=template&id=7ecf7945&scoped=true"
import script from "./zcfzTable.vue?vue&type=script&lang=js"
export * from "./zcfzTable.vue?vue&type=script&lang=js"

import "./zcfzTable.vue?vue&type=style&index=0&id=7ecf7945&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecf7945"]])

export default __exports__